const mobileMenuTrigger = document.querySelector('.mobile-menu__trigger');
const mobileSubmenuTriggers = document.querySelectorAll('.has-submenu');

if (mobileMenuTrigger) {
    const body = document.body;
    const bodyInner = document.querySelector('.body-inner');
    const header = document.querySelector('.header');
    const navIcon = document.querySelector('.nav-icon');
    
    mobileMenuTrigger.addEventListener('click', function () {
        navIcon.classList.toggle('open');
        header.classList.toggle('active');
        body.classList.toggle('overflow-hidden');
        bodyInner.classList.toggle('mobile-menu-active');
    });
}

if (mobileSubmenuTriggers.length) {
    [].forEach.call(mobileSubmenuTriggers, trigger => {
        trigger.addEventListener('click', (e) => {
            trigger.classList.toggle('active');
        });
    });
}